module.exports = __webpack_public_path__ + "static/media/add.6a3b5d95.svg";